// Modules
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import _ from 'lodash';
import moment from 'moment';

import { PageContent } from 'components/page';
import { PrimaryButton } from 'components/widgets/buttons/buttons';
import { RoundLoader } from 'components/widgets/state-indicators/loader';
import AddTask from 'components/models/ticket/add-task';
import FlipMove from 'components/widgets/animation/flip-move';
import Task from 'services/data/task';
import TaskComponent from 'components/models/ticket/task';

import useTicket from '../hooks/useTicket';


function TicketTasks({ params }) {
  const [showAllClosedTasks, setShowAllClosedTasks] = useState(false);
  const closedTaskLimit = showAllClosedTasks ? 100000 : 10;
  const {
    ticket,
    closedTasks,
    closedTaskCount,
    isFetchingClosedTasks,
    updateTask,
    updateTicket,
    saveNewTask
  } = useTicket(params.ticketId, { closedTaskLimit });
  
  if (!ticket || _.isEmpty(ticket) || !closedTasks) return null;

  const isArchived = ticket.status === 'Archived';
  const openTasks = Task.sort(ticket.tasks);

  return (
    <PageContent className="bg-medium-blue-grey ticket">
      <div className="ticket-tasks">
        <div className="tasks open-tasks">
          { !isArchived && <AddTask saveTask={saveNewTask} updateTicket={updateTicket} ticket={ticket} cancelAddTask={_.noop} /> }
          <ul className="unstyled-list">
            <FlipMove>
              {_.map(openTasks, (task) =>
                <TaskComponent
                  key={task.uuid}
                  task={task}
                  updateTask={(updates, ticketUpdates) => updateTask({ ..._.pick(task, ['uuid', 'ticket']), ...updates }, ticketUpdates)}
                  updateTicket={updateTicket}
                  ticket={ticket}
                  inTicket
                />
              )}
            </FlipMove>
          </ul>
        </div>
        <div className="tasks closed-tasks">
          {isFetchingClosedTasks && 
            <div class="pt-5 d-flex justify-content-center align-items-center">
              <RoundLoader style={{ width: 50, height: 50 }} color="#34495e" />
            </div>
          }
          <ul className="unstyled-list">
            <FlipMove>
              {_.map(closedTasks, (task) =>
                <div key={task.uuid}>
                  <TaskComponent
                    task={task}
                    updateTask={(updates, ticketUpdates) => updateTask({ ..._.pick(task, ['uuid', 'ticket']), ...updates }, ticketUpdates)}
                    updateTicket={updateTicket}
                    ticket={ticket}
                    inTicket
                  />
                </div>
              )}
            </FlipMove>
          </ul>
          { closedTaskCount > closedTaskLimit &&
            <div className="d-flex align-items-center justify-content-center">
              <h4 className="mb-0 mr-3">{closedTaskCount - closedTaskLimit} more closed tasks hidden</h4>
              <PrimaryButton onClick={() => setShowAllClosedTasks(true)}>Show All</PrimaryButton>
            </div>
          }
        </div>
      </div>
    </PageContent>
  );
}

TicketTasks.propTypes = {
  params: PropTypes.object
};

export default TicketTasks;
